class Bourse {
    static init() {
        if (document.querySelector('.flexbourse')) {

            const isin = document.querySelector('.flexbourse__isin');
            const date = document.querySelector('.flexbourse__date');
            const montant = document.querySelector('.flexbourse__montant');
            const evolution = document.querySelector('.flexbourse__evolution');
            var requestOptions = {
                method: 'GET'
            };

            fetch(`${genJson.apiBourse}?lang=${genJson.lang}`, requestOptions)
                .then(response => response.json())
                .then(result => {
                    isin.innerText = `${result.codification} : ${result.code}`;
                    date.innerText = `EPA: ALCAR - ${result.date}`;
                    montant.innerText = `${result.value} €`;
                    if (parseFloat(result.changed.replace(/,/g, '.')) < 0) {
                        evolution.classList.add('down')
                    } else {
                        evolution.classList.remove('down')
                    }
                    evolution.innerText = `${result.changed}`;
                })
                .catch(error => console.log('error', error));
        }
    }
}

export default Bourse;


// WEBPACK FOOTER //
// ./src/scripts/components/bourse.js